import { FC } from 'react';
import styled from 'styled-components';

import Stack from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';

const NullStateContainer = styled(Stack)`
  height: 100px;
`;

interface NullStateProps {
  message: string;
}
const NullState: FC<NullStateProps> = ({ message }) => {
  return (
    <NullStateContainer align='center' justify='center'>
      <Label>{message}</Label>
    </NullStateContainer>
  );
};

export default NullState;
